<form [formGroup]="repeatScheduleForm" (submit)="onRepeatSchedule()" *ngIf="repeatScheduleForm">
  <div class="d-flex">
    <app-toggle [fieldObject]="isRepeatScheduleObject" [fieldErrors]="fvRepeatSchedule.formErrors"
      [formControlRef]="isRepeatScheduleControl"></app-toggle>
  </div>
  <ng-container *ngIf="isRepeatScheduleControl.value==true">
    <div class="row mt-2">
      <div class="col-md-5" style="margin-top: 0;">
        <app-multi-select-trigger [fieldObject]="repeatEveryObject" [fieldErrors]="fvRepeatSchedule.formErrors"
          [formControlRef]="convertControls('Repeat Every')" [inputHeight]="'47px'">
        </app-multi-select-trigger>
      </div>
      <div class="col-md-5 marginTop" >
        <app-date-now [fieldObject]="repeatUntilObject" [fieldErrors]="fvRepeatSchedule.formErrors"
          [formControlRef]="convertControls('Repeat Untill')">
          [maxDate]="maxDate"
        </app-date-now>
      </div>
      <div class="col-md-2 marginTop">
        <button class="btn btn-success" type="submit" [disabled]="!isDayScheduleValid">{{
          'Home.CalendarSlots.Repeat' | translate}}</button>
      </div>
    </div>
  </ng-container>
</form>
